const RELATION_TAG_TONES = 6

/** 关联解锁方式 tag：按 id hash 分配稳定 tone，避免随机色每次渲染变化。 */
export function getRelationTagTone(id) {
  const raw = String(id == null ? '' : id)
  let hash = 0
  for (let i = 0; i < raw.length; i += 1) {
    hash = (hash * 31 + raw.charCodeAt(i)) >>> 0
  }
  return hash % RELATION_TAG_TONES
}

/** 解锁方式 pill：常见类型走固定色，其余 neutral。 */
export function getLockTypeVariant(lockType) {
  const key = String(lockType || '').trim()
  if (!key) return 'neutral'
  if (key.includes('免费')) return 'teal'
  if (key.includes('金币')) return 'amber'
  if (key.includes('视频')) return 'sky'
  if (key.includes('内购')) return 'violet'
  if (key.includes('代币')) return 'rose'
  if (key.includes('拼图')) return 'indigo'
  if (key.includes('神秘')) return 'link'
  return 'neutral'
}

export function getVisibleRelations(items) {
  return (items || []).slice(0, 3)
}

export function getHiddenRelationCount(items) {
  return Math.max(0, (items || []).length - 3)
}
